import React, { useCallback, useMemo } from 'react';

import { Box } from '@atlaskit/primitives/compiled';
import { useGetSpaceIdsFromSpaceKeys, useProductDependencies } from '@atlassian/company-hub-common';
import {
	ProductKeys,
	SearchPage as SearchHub,
	type UserDetails,
} from '@atlassian/dynamic-cards-search-page';

import type { Filters } from '../../../../../../types';

type SearchHubContainerProps = {
	filters: Filters;
	setFilters: (filters: Filters) => void;
};

export const SearchHubContainer = ({
	filters,
	setFilters,
}: SearchHubContainerProps): React.JSX.Element => {
	const { cloudId, userId, displayName, orgId, isAdminHubAIEnabled } = useProductDependencies();

	const getSpaceIdsFromSpaceKeys = useGetSpaceIdsFromSpaceKeys();

	const userDetails = useMemo<UserDetails>(() => {
		return {
			id: userId ?? null,
			name: displayName ?? null,
		};
	}, [userId, displayName]);

	const mapUserIdToProfileUrl = useCallback((userId: string) => `/wiki/people/${userId}`, []);

	return (
		<Box testId="search-hub-container">
			<SearchHub
				shell={{
					cloudId,
					orgId,
					user: userDetails,
					primaryProduct: ProductKeys.Confluence,
					queryParams: filters,
					isAdminHubAIEnabled,
				}}
				callbacks={{
					updateQueryParameters: setFilters,
					getSpaceIdsFromSpaceKeys,
				}}
				mapUserIdToProfileUrl={mapUserIdToProfileUrl}
			/>
		</Box>
	);
};
